module.exports = __webpack_public_path__ + "assets/img/novo-header-impressao.60ea47d7.jpeg";